import { Group as RadixGroup } from '@radix-ui/react-dropdown-menu';
import clsx from 'clsx';
import { forwardRef, Children } from 'react';

import {
  type DataTestId,
  type StylingProps,
  type WithChildren,
  type AriaLabelingProps,
} from '@dynatrace/strato-components/core';

import * as styles from './Menu.sty.js';

/**
 * @public
 */
export interface MenuGroupProps
  extends WithChildren,
    AriaLabelingProps,
    StylingProps,
    DataTestId {}

/**
 * Used to group multiple items.
 * @public
 */
export const Group = /* @__PURE__ */ forwardRef<HTMLDivElement, MenuGroupProps>(
  (props, forwardedRef) => {
    const {
      children,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      'aria-describedby': ariaDescribedBy,
      'aria-details': ariaDetails,
      className: consumerClassName,
      style: consumerStyle,
      'data-testid': dataTestId,
    }: MenuGroupProps = props;
    const hasChildren = Children.count(children) > 0;

    return hasChildren ? (
      <RadixGroup
        className={clsx(styles.group, consumerClassName)}
        ref={forwardedRef}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-describedby={ariaDescribedBy}
        aria-details={ariaDetails}
        data-testid={dataTestId}
        style={consumerStyle}
      >
        {children}
      </RadixGroup>
    ) : null;
  },
);

(Group as typeof Group & { displayName: string }).displayName = 'Menu.Group';
